'use client';
import { isNumber } from '@s7/utils';
import { em, rem } from '../units/units.js';

function getSize(options) {
    const { size, sizes, units, mapper } = options;
    if (size !== undefined && size !== null) {
        if (sizes !== undefined && size in sizes) {
            return sizes[size];
        }
        if (isNumber(size)) {
            let value = size;
            if (mapper) {
                value = mapper(value);
            }
            return value === 0 ? 0 : units === 'em' ? em(value) : rem(value);
        }
    }
    return size || (sizes == null ? void 0 : sizes.md1) || 0;
}

export { getSize };
//# sourceMappingURL=getSize.js.map
